import { render, staticRenderFns } from "./TradingCentralComponent.vue?vue&type=template&id=5eabaca2&scoped=true&"
import script from "./TradingCentralComponent.vue?vue&type=script&lang=js&"
export * from "./TradingCentralComponent.vue?vue&type=script&lang=js&"
import style0 from "./TradingCentralComponent.vue?vue&type=style&index=0&id=5eabaca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabaca2",
  null
  
)

export default component.exports